function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { bool, node, shape, string, oneOfType, number } from "prop-types";
import { components } from "react-select";
import classNamesMaker from "classnames";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import { Text, TEXT_COLORS, TEXT_TYPES } from "#library/components/Text/Text";
import check from "#library/assets/icons/jds_check.svg";
import { DATA_SPACER } from "#library/constants/enums";
import styles from "./option.module.css";
export var Option = function Option(props) {
  var children = props.children,
    _props$isSelected = props.isSelected,
    isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$data = props.data,
    iconXlinkHref = _props$data.iconXlinkHref,
    count = _props$data.count;
  var countDisplayable = count === null || count === void 0 ? void 0 : count.toString();
  var iconClassNames = classNamesMaker(styles["jds-Option__icon"], _defineProperty({}, styles["jds-Option__icon--selected"], isSelected));
  var wrapperClassNames = classNamesMaker(styles["jds-Option__wrapper"]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles["jds-Option__outer"]
  }, /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, iconXlinkHref && /*#__PURE__*/React.createElement(Icon, {
    xlinkHref: iconXlinkHref,
    size: ICON_SIZES.MEDIUM,
    dataSpacer: DATA_SPACER.RIGHT_100
  }), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-Option"]
  }, children, countDisplayable && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    color: isDisabled ? TEXT_COLORS.GREY_LIGHT : TEXT_COLORS.GREY,
    type: TEXT_TYPES.SMALL,
    dataSpacer: DATA_SPACER.LEFT_100
  }, "(", countDisplayable, ")")), /*#__PURE__*/React.createElement(Icon, {
    xlinkHref: "#".concat(check.id),
    size: ICON_SIZES.SMALL,
    className: iconClassNames
  }))));
};
Option.propTypes = {
  children: node.isRequired,
  isSelected: bool,
  isDisabled: bool,
  data: shape({
    iconXlinkHref: string,
    count: oneOfType([string, number])
  }).isRequired
};